import styled from 'styled-components';

import { RootFieldIcons, RootFieldInput } from '../_shared/styled';

const FieldInput = styled(RootFieldInput)`
  padding: ${({ appendIcon }) => (appendIcon ? '16px 48px 16px 16px' : '16px')};
  padding: ${({ prependSymbol }) =>
    prependSymbol ? '16px 16px 16px 26px' : '16px'};

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    margin: 0;
  }
`;

const FieldIcons = styled(RootFieldIcons)`
  right: 12px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover > button > svg {
    fill: ${({ theme }) => theme.graniteGray};
  }

  & > button {
    &:focus {
      & > svg {
        fill: ${({ theme }) => theme.graniteGray};
      }
    }

    &:active {
      & > svg {
        fill: ${({ theme }) => theme.outerSpace};
      }
    }
  }
`;

const PrependSymbolStyled = styled.div`
  position: absolute;
  top: 30%;
  left: 10px;
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.gray950};
`;

export { FieldInput, FieldIcons, PrependSymbolStyled };
